import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../app/modules/auth";
import {
	DrawerComponent,
	MenuComponent,
	ScrollComponent,
	ScrollTopComponent,
	SwapperComponent,
	ToggleComponent,
} from "../assets/ts/components";
import IdleTracker from "../helpers/IdleTracker";
import {
	ActivityDrawer,
	DrawerMessenger,
	InviteUsers,
	UpgradePlan,
} from "../partials";
import { RightToolbar } from "../partials/layout/RightToolbar";
import { AsideDefault } from "./components/aside/AsideDefault";
import { Content } from "./components/Content";
import { Footer } from "./components/Footer";
import { HeaderWrapper } from "./components/header/HeaderWrapper";
import { ScrollTop } from "./components/ScrollTop";
import { PageDataProvider } from "./core";

const MasterLayout = () => {
	const _location = useLocation();
	const { logout } = useAuth();

	const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < 992);
		window.addEventListener("resize", handleResize);

		setTimeout(() => {
			ToggleComponent.reinitialization();
			ScrollTopComponent.reinitialization();
			DrawerComponent.reinitialization();
			MenuComponent.reinitialization();
			ScrollComponent.reinitialization();
			SwapperComponent.reinitialization();
		}, 500);

		return () => window.removeEventListener("resize", handleResize);
	}, []);
	const handleIdle = () => {
		// alert("You have been idle for too long!");
		// toast.warn("You have been idle for too long!.Please log in again.");
		toast.info("You have been idle for too long!.Please log in again.", {
			position: "top-center",
			autoClose: 30000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		});
		logout();
	};
	return (
		<PageDataProvider>
			<div className="page d-flex flex-row flex-column-fluid">
				<AsideDefault />
				<div
					className={`wrapper d-flex flex-column flex-row-fluid ${isMobile ? "pt-0" : ""}`}
					id="kt_wrapper"
				>
					<IdleTracker idleLimit={600000 * 10} onIdle={handleIdle} />
					<HeaderWrapper />

					<div
						id="kt_content"
						className="content d-flex flex-column flex-column-fluid main-bg"
					>
						<div className="post d-flex flex-column-fluid mb-5" id="kt_post">
							<Content>
								<Outlet />
							</Content>
						</div>
					</div>
					<Footer />
				</div>
			</div>

			{/* begin:: Drawers */}
			<ActivityDrawer />
			<RightToolbar />
			<DrawerMessenger />
			{/* end:: Drawers */}

			{/* begin:: Modals */}
			<InviteUsers />
			<UpgradePlan />
			{/* end:: Modals */}
			<ScrollTop />
		</PageDataProvider>
	);
};

export { MasterLayout };
